<template>
  <div data-v-a12142ec="" data-v-2ac6a5fc="" class="aboutNew">
    <div data-v-a12142ec="" class="sect1">
      <div data-v-a12142ec="" class="box">
        <div data-v-a12142ec="" class="detail">
          <h1 data-v-a12142ec="">{{$store.state.appInfo.title}}优势</h1>
          <p data-v-a12142ec="">单日提款高达<span data-v-a12142ec="">2,000万</span></p>
          <p data-v-a12142ec="">随时洗码1秒到账</p>
          <p data-v-a12142ec="">单笔下注高达<span data-v-a12142ec="">200万</span></p>
          <p data-v-a12142ec="">支持<span data-v-a12142ec="">USDT、BTC</span>多币种到账</p>
          <p data-v-a12142ec="">澳门、菲律宾各大<span data-v-a12142ec="">赌场出款</span></p>
        </div>
      </div>
    </div>
    <div data-v-a12142ec="" class="sect2">
      <h1 data-v-a12142ec="">众多游戏平台</h1>
      <p data-v-a12142ec="">我们提供丰富游戏项目：百家乐、龙宝、骰宝、21点、体育竞技、轮盘、炸金花、三公、温州牌九、牛牛、德州扑克等</p>
      <div data-v-a12142ec="" class="gameList">
        <div data-v-a12142ec="" class="gthmb">
          <div data-v-a12142ec="" class="item"><img data-v-a12142ec="" src="/static/image/game1.8495e00d.png" /></div>
          <div data-v-a12142ec="" class="item"><img data-v-a12142ec="" src="/static/image/game2.f196b9de.png" /></div>
          <div data-v-a12142ec="" class="item"><img data-v-a12142ec="" src="/static/image/game3.abcdaab4.png" /></div>
        </div>
        <div data-v-a12142ec="" class="gthmb">
          <div data-v-a12142ec="" class="item"><img data-v-a12142ec="" src="/static/image/game4.775a38b6.png" /></div>
          <div data-v-a12142ec="" class="item"><img data-v-a12142ec="" src="/static/image/game5.800cf51f.png" /></div>
          <div data-v-a12142ec="" class="item"><img data-v-a12142ec="" src="/static/image/game6.e05e5861.png" /></div>
        </div>
      </div>
    </div>
    <div data-v-a12142ec="" class="sect3">
      <h1 data-v-a12142ec="">年度报告</h1>
      <div data-v-a12142ec="" class="reportList">
        <div data-v-a12142ec="" class="item">

          <p data-v-a12142ec="">全年成交2089亿</p>
          <p data-v-a12142ec="">新增会员注册用户532.64万人</p>
          <p data-v-a12142ec="">全年送出优惠高达12.14亿元</p>
          <p data-v-a12142ec=""><span data-v-a12142ec="" class="dots">• • •</span></p>
        </div>
        <div data-v-a12142ec="" class="item">

          <p data-v-a12142ec="">全年成交1971.82亿</p>
          <p data-v-a12142ec="">新增会员注册用户323.05万人</p>
          <p data-v-a12142ec="">全年送出优惠高达12.1亿元</p>
          <p data-v-a12142ec=""><span data-v-a12142ec="" class="dots">• • •</span></p>
        </div>
        <div data-v-a12142ec="" class="item">

          <p data-v-a12142ec="">全年成交1507.61亿</p>
          <p data-v-a12142ec="">新增会员数较2015年增长159.63%</p>
          <p data-v-a12142ec="">全年送出优惠高达7.9亿元</p>
          <p data-v-a12142ec=""><span data-v-a12142ec="" class="dots">• • •</span></p>
        </div>
      </div>
    </div>
    <div data-v-a12142ec="" class="sect4">
      <div data-v-a12142ec="" class="banner"><img data-v-a12142ec="" src="/static/image/banner.df0ea208.jpg" /></div>
      <p data-v-a12142ec="">AG现场参观豪华游艇主题party，邀您感受菲律宾的热情</p>
    </div>
    <div data-v-a12142ec="" class="sect5">
      <h1 data-v-a12142ec="">全民俱乐部</h1>
      <p data-v-a12142ec="">每月8/18/28爽领分红</p>
      <div data-v-a12142ec="" class="shareholderList">
        <p data-v-a12142ec=""><i data-v-a12142ec="" class="orb1"></i><span data-v-a12142ec="">专属经理</span> 一对一服务</p>
        <p data-v-a12142ec=""><i data-v-a12142ec="" class="orb2"></i><span data-v-a12142ec="">专属域名</span> 私人定制专属通道</p>
        <p data-v-a12142ec=""><i data-v-a12142ec="" class="orb3"></i><span data-v-a12142ec="">月月分红</span> 最高可享200,000股</p>
        <p data-v-a12142ec=""><i data-v-a12142ec="" class="orb4"></i><span data-v-a12142ec="">账号回购</span> {{$store.state.appInfo.title}}官方保底账号回购1,400,000元</p>
        <p data-v-a12142ec=""><i data-v-a12142ec="" class="orb5"></i><span data-v-a12142ec="">晋级礼金</span> 累计最高可享6,015,500元</p>
        <p data-v-a12142ec=""><i data-v-a12142ec="" class="orb6"></i><span data-v-a12142ec="">免息贷款</span> 最高可享1,400,000元</p>
      </div>
    </div>
    <div data-v-a12142ec="" class="sect6">
      <h1 data-v-a12142ec="">品牌发展历程</h1>
      <div data-v-a12142ec="" class="promoList" style="overflow: hidden">
        <div data-v-a12142ec="" class="gthmb" style="overflow: hidden">
          <div data-v-a12142ec="" class="item left"><img data-v-a12142ec="" src="/static/image/promo1.a575b4d1.png" /></div>
          <div data-v-a12142ec="" class="item left"><img data-v-a12142ec="" src="/static/image/promo2.ff3c67ac.png" /></div>
        </div>
        <div data-v-a12142ec="" class="gthmb">
          <div data-v-a12142ec="" class="item left"><img data-v-a12142ec="" src="/static/image/promo3.b3847e9f.png" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  data() {
    return {};
  },
  methods: {},
  mounted() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-29f356a8.d5c1690a.css';
</style>



// WEBPACK FOOTER //
// src/components/main/about.vue